define('drops/ganttChart/ganttChart',[
    'jquery',
    'globalize',
    'lq/frontendModules',
    'lq/drop',
    'lq/style',
    'lq/constants',
    'lq/types',
    'lq/multiSourceValue',
    'lq/parameterBinding'
], function ($, globalize, FrontendModules, Drop, Style, constants, types, multiSourceValue, parameterBinding) {
    'use strict';

    var defaults = {
        data: {
            // Dependencies
            dependenciesEnabled: false,
            dependencyArrowRemoverEnabled: true,

            // Holidays
            holidaysEnabled: false,

            // Grid
            scrollbarVisible: true,
            defaultZoomLevel: 0,

            // Header 
            headerHeight: 80,
            strongYearFormat: "numeric",
            strongMonthFormat: "long",
            strongWeekDayFormat: "narrow",
            mediumMonthFormat: "long",
            lightMonthFormat: "short",

            // Bar
            barLabelPosition: "before",

            // Styling
            boxShadowColor: "#000000",
            toolbarIconHoverColor: "#2a84bf",

            headerFill: "#ffffff",
            headerRowWrapperLineColor: "#a6a6a6",
            headerRowLineColor: "#b8b8b8",
            headerRowCellLineColor: "#c7c7c7",
            headerHorizontalLineColor: "#c7c7c7",

            cellFill: "#ffffff",
            weekendFill: "#ebe9eb",
            holidayFill: "#a6d1ed",
            horizontalGridLinesVisible: true,
            horizontalGridLinesColor: "#c7c7c7",
            dayLinesColor: "#c7c7c7",
            monthLinesColor: "#b8b8b8",
            yearLinesColor: "#a6a6a6"
        }
    };

    function GanttChart(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        Style.renderStyles(this);

        this.bindings = undefined;
    };

    Drop.extend(GanttChart, Drop);

    GanttChart.typeName = 'GanttChart';

    GanttChart.prototype.preRender = function () {
        this.GanttChartComponent = null;

        this.applyPosition();

        var self = this;

        this.tasksDataSourceListenerId = this.piping.datasources.registerDatasourceListener(
            this.data.tasksDataSource,
            function (data) {
                self.taskData = data.results.map(function (result) {
                    return {
                        id: result[self.data.taskId],
                        name: result[self.data.taskName],
                        start: result[self.data.taskStart].substring(0, 10),
                        end: result[self.data.taskEnd].substring(0, 10),
                        position: result[self.data.taskPosition],
                        color: result[self.data.taskColor],
                        textColor: result[self.data.textColor],
                    };
                });

                if (self.GanttChartComponent) {
                    self.GanttChartComponent.setTasksL(self.taskData);
                }
            });

        if (this.data.dependenciesEnabled) {
            this.dependenciesDataSourceListenerId = this.piping.datasources.registerDatasourceListener(
                this.data.dependenciesDataSource,
                function (data) {
                    self.dependencyData = data.results.map(function (result) {
                        return {
                            id: result[self.data.dependencyId],
                            fromTaskId: result[self.data.dependencyFromTaskId],
                            toTaskId: result[self.data.dependencyToTaskId]
                        };
                    });

                    if (self.GanttChartComponent) {
                        self.GanttChartComponent.setDependenciesL(self.dependencyData);
                    }
                }
            );
        }

        if (this.data.holidaysEnabled) {
            this.holidaysDataSourceListenerId = this.piping.datasources.registerDatasourceListener(
                this.data.holidaysDataSource,
                function (data) {
                    self.holidaysData = data.results.map(function (result) {
                        return {
                            id: result[self.data.holidayId],
                            date: result[self.data.holidayDate].substring(0, 10),
                        };
                    });

                    if (self.GanttChartComponent) {
                        self.GanttChartComponent.setHolidaysL(self.holidaysData);
                    }
                }
            );
        }

        FrontendModules.load('ganttChart', true)
            .then(this.showComponent.bind(this));
    };

    GanttChart.prototype.showComponent = function (GanttChartComponentRendered) {
        var self = this;

        GanttChartComponentRendered.default({
            changeTask: function (taskId, newStartDate, newEndDate) {
                self.piping.parameters.locals.setValue(self.data.taskIdParameter, taskId);
                self.piping.parameters.locals.setValue(self.data.taskStartParameter, globalize.format(new Date(newStartDate), constants.licquidDateFormat));
                self.piping.parameters.locals.setValue(self.data.taskEndParameter, globalize.format(new Date(newEndDate), constants.licquidDateFormat));

                self.triggerEventIfEnabled('taskChanged');
            },
            taskClicked: function (taskId, startDate, endDate) {
                self.piping.parameters.locals.setValue(self.data.taskIdParameter, taskId);
                self.piping.parameters.locals.setValue(self.data.taskStartParameter, globalize.format(new Date(startDate), constants.licquidDateFormat));
                self.piping.parameters.locals.setValue(self.data.taskEndParameter, globalize.format(new Date(endDate), constants.licquidDateFormat));

                self.triggerEventIfEnabled('taskClicked');
            },
            taskHovered: function (taskId, startDate, endDate) {
                self.piping.parameters.locals.setValue(self.data.taskIdParameter, taskId);
                self.piping.parameters.locals.setValue(self.data.taskStartParameter, globalize.format(new Date(startDate), constants.licquidDateFormat));
                self.piping.parameters.locals.setValue(self.data.taskEndParameter, globalize.format(new Date(endDate), constants.licquidDateFormat));

                self.triggerEventIfEnabled('taskHovered');
            },
            zoomLevelChanged: function (zoomLevel) {
                self.piping.parameters.locals.setValue(self.data.currentZoomLevelParameter, zoomLevel);

                self.triggerEventIfEnabled('zoomLevelChanged', zoomLevel);
            },
            focusedDateChanged: function (focusedDate) {
                var formattedFocusedDate = globalize.format(new Date(focusedDate), constants.licquidDateFormat);

                self.piping.parameters.locals.setValue(self.data.currentFocusedDateParameter, formattedFocusedDate);

                self.triggerEventIfEnabled('focusedDateChanged', formattedFocusedDate);
            },
            addDependency: function (dependencyId, fromTaskId, toTaskId) {
                self.piping.parameters.locals.setValue(self.data.dependencyIdParameter, dependencyId);
                self.piping.parameters.locals.setValue(self.data.dependencyFromTaskIdParameter, fromTaskId);
                self.piping.parameters.locals.setValue(self.data.dependencyToTaskIdParameter, toTaskId);

                self.triggerEventIfEnabled('dependencyAdded');
            },
            deleteDependency: function (dependencyId) {
                self.piping.parameters.locals.setValue(self.data.dependencyIdParameter, dependencyId);

                self.triggerEventIfEnabled('dependencyDeleted');
            },
            dependencyClicked: function (dependencyId, fromTaskId, toTaskId) {
                self.piping.parameters.locals.setValue(self.data.dependencyIdParameter, dependencyId);
                self.piping.parameters.locals.setValue(self.data.dependencyFromTaskIdParameter, fromTaskId);
                self.piping.parameters.locals.setValue(self.data.dependencyToTaskIdParameter, toTaskId);

                self.triggerEventIfEnabled('dependencyClicked');
            },

        }, this.$element.get(0));

        if (this.taskData) {
            GanttChartComponentRendered.setTasksL(this.taskData);
        }

        if (this.dependencyData) {
            GanttChartComponentRendered.setDependenciesL(this.dependencyData);
        }

        if (this.holidaysData) {
            GanttChartComponentRendered.setHolidaysL(this.holidaysData);
        }

        GanttChartComponentRendered.configureGanttChart({
            cellHeight: this.data.cellHeight,
            barHeight: this.data.barHeight,
            barLabelPosition: this.data.barLabelPosition,
            toolbarHeight: this.data.toolbarHeight,
            scrollbarVisible: this.data.scrollbarVisible,
            dependenciesEnabled: this.data.dependenciesEnabled,
            dependencyArrowRemoverEnabled: this.data.dependenciesEnabled && this.data.dependencyArrowRemoverEnabled,
            defaultZoomLevel: this.data.defaultZoomLevel,
            boxShadowColor: this.data.boxShadowColor,
            toolbarIconHoverColor: this.data.toolbarIconHoverColor,
            focusedDate: this.data.useFocusedDate ? parameterBinding.getValue(this, this.data.focusedDate) : undefined,
            viewStart: this.data.useStartDate ? parameterBinding.getValue(this, this.data.startDate) : undefined,
            viewEnd: this.useEndDate ? parameterBinding.getValue(this, this.data.endDate) : undefined,
            readOnly: this.useReadOnly ? multiSourceValue.getValue(this, this.data.readOnly) : undefined
        });

        GanttChartComponentRendered.configureHeader({
            languageCode: this.piping.parameters.getValue('CurrentLanguageISOCode'),
            headerHeight: this.data.headerHeight,
            strongYearFormat: this.data.strongYearFormat,
            strongMonthFormat: this.data.strongMonthFormat,
            strongWeekDayFormat: this.data.strongWeekDayFormat,
            mediumMonthFormat: this.data.mediumMonthFormat,
            lightMonthFormat: this.data.lightMonthFormat,
            headerFill: this.data.headerFill,
            headerRowWrapperLineColor: this.data.headerRowWrapperLineColor,
            headerRowLineColor: this.data.headerRowLineColor,
            headerRowCellLineColor: this.data.headerRowCellLineColor,
            headerHorizontalLineColor: this.data.headerHorizontalLineColor,
        });

        GanttChartComponentRendered.configureCells({
            cellFill: this.data.cellFill,
            weekendFill: this.data.weekendFill,
            holidayFill: this.data.holidayFill,
            horizontalGridLinesVisible: this.data.horizontalGridLinesVisible,
            horizontalGridLinesColor: this.data.horizontalGridLinesColor,
            dayLinesColor: this.data.dayLinesColor,
            monthLinesColor: this.data.monthLinesColor,
            yearLinesColor: this.data.yearLinesColor,
        });

        this.GanttChartComponent = GanttChartComponentRendered;

        multiSourceValue.initializeUpdates(
            this,
            this.data.readOnly,
            this.updateReadOnlyParameter.bind(this)
        );
        
        if(this.data.useFocusedDate) {
            parameterBinding.initializeUpdates(
                this,
                this.data.focusedDate,
                this.updateFocusedDateParameter.bind(this)
            );
        }

        if(this.data.useStartDate) {
            parameterBinding.initializeUpdates(
                this,
                this.data.startDate,
                this.updateViewStartParameter.bind(this)
            );
        }

        if(this.data.useEndDate) {
            parameterBinding.initializeUpdates(
                this,
                this.data.endDate,
                this.updateViewEndParameter.bind(this)
            );
        }
    };

    GanttChart.prototype.updateFocusedDateParameter = function (focusedDate) {
        if (focusedDate !== undefined && focusedDate !== null)
            this.GanttChartComponent.updateFocusedDateParameter(types.parseDate(focusedDate));
    };

    GanttChart.prototype.updateViewStartParameter = function (startDate) {
        if (startDate !== undefined && startDate !== null)
            this.GanttChartComponent.updateViewStartParameter(types.parseDate(startDate));
    };

    GanttChart.prototype.updateViewEndParameter = function (endDate) {
        if (endDate !== undefined && endDate !== null)
            this.GanttChartComponent.updateViewEndParameter(types.parseDate(endDate));
    };

    GanttChart.prototype.updateReadOnlyParameter = function (readOnly) {
        if (readOnly !== undefined && readOnly !== null)
            this.GanttChartComponent.updateReadOnlyParameter(types.parseBoolean(readOnly));
    };
    
    GanttChart.prototype.unsubscribeEventHandlers = function () {
        if (this.tasksDataSourceListenerId) {
            this.piping.datasources.unregisterDatasourceListener(this.tasksDataSourceListenerId);
        }

        if (this.dependenciesDataSourceListenerId) {
            this.piping.datasources.unregisterDatasourceListener(this.dependenciesDataSourceListenerId);
        }

        if (this.holidaysDataSourceListenerId) {
            this.piping.datasources.unregisterDatasourceListener(this.holidaysDataSourceListenerId);
        }
    };

    return GanttChart;
});
